import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"

export const IFrameWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;
  height: 100%;
  ${minWidthMedia.tablet`
    height: 315px;
  `}
`

export const IFrame = styled.iframe`
  border: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`
